<form #form="rxapForm" rxapForm>

  <mat-form-field class="w-full" subscriptSizing="dynamic">

    <mat-label>{{ label() }}</mat-label>

    <input
       #autocompleteInput
      [matAutocomplete]="autoItem"
      [placeholder]="placeholder()"
      placeholder="{{ selectedItems().length > 2 ? '' : placeholder() }}"
      autocomplete="off"
      formControlName="item"
      matInput
      rxapRequired
      type="text"
      [matChipInputFor]="chipGrid"
      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
    />

    <mat-chip-grid class="absolute top-0 right-0" #chipGrid>
      @for (selectedOption of displayedSelectedOptions(); track $index) {
        <mat-chip-row (removed)="removeItem(selectedOption.uuid)">
          <div class="flex flex-row gap-2">
            <span class="truncate max-w-[80px]" [matTooltip]="selectedOption.name">{{ selectedOption.name }}</span>
            <button matChipRemove>
              <mat-icon>cancel</mat-icon>
            </button>
          </div>
        </mat-chip-row>
      }
      @if (remainingSelectedOptionsNames().length > 0) {
        <mat-chip-row>
          <div>
            @if (maxNumberOfDisplayedChips() > 1) {
              <span [matTooltip]="remainingSelectedOptionsNames().join(', ')">and {{ remainingSelectedOptionsNames().length }} others</span>
            } @else {
              <span [matTooltip]="remainingSelectedOptionsNames().join(', ')">{{ remainingSelectedOptionsNames().length }} selected</span>
            }
          </div>
        </mat-chip-row>
      }
    </mat-chip-grid>

    <mat-autocomplete #autoItem="matAutocomplete" (optionSelected)="optionSelected($event)">
      <mat-option
        *rxapAutocompleteOptionsFromMethod="let option; matAutocomplete: autoItem"
        [value]="option.value"
      >
        {{ option.display }}
      </mat-option>
    </mat-autocomplete>

    <button mat-icon-button matSuffix rxapInputClearButton tabindex="-1" type="button">
      <mat-icon>clear</mat-icon>
    </button>

    <mat-error *rxapControlError="let erro; key: 'required'">
      {{ label() }}
      <ng-container i18n>is required</ng-container>
    </mat-error>
    <mat-error *rxapControlError="let erro; key: 'autocomplete'">
      {{ label() }}
      <ng-container i18n>is not valid</ng-container>
    </mat-error>
    @if (!useChips()) {
      <mat-hint>
        <ng-container i18n>Search for a</ng-container>
        {{ label() }}
      </mat-hint>
    }
  </mat-form-field>

</form>
